/* Dress Collar — global chrome behavior.
   No dependencies. Progressive enhancement: no-JS = fully visible. */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // If an announcement bar is present, nudge the nav down to sit below it.
  if (document.querySelector('.dc-announce')) {
    var navEl = document.querySelector('.dc-nav');
    if (navEl) navEl.classList.add('dc-has-announce');
  }

  // ---------- Sticky-nav state + hide announcement on scroll ----------
  var SCROLL_THRESHOLD = 60;
  var lastScroll = 0;
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (y > SCROLL_THRESHOLD) document.body.classList.add('dc-scrolled');
    else document.body.classList.remove('dc-scrolled');
    var nav = document.querySelector('.dc-nav');
    if (nav) {
      if (y > SCROLL_THRESHOLD) nav.classList.add('dc-solid');
      else nav.classList.remove('dc-solid');
    }
    lastScroll = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---------- Mobile menu ----------
  var burger = document.querySelector('.dc-nav-burger');
  var mobileMenu = document.querySelector('.dc-mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('dc-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        mobileMenu.classList.remove('dc-open');
        document.body.style.overflow = '';
      }
    });
  }

  // ---------- Cart drawer open/close ----------
  var cartTriggers = document.querySelectorAll('[data-dc-cart-open]');
  var cartClose = document.querySelectorAll('[data-dc-cart-close]');

  function openCart() {
    var drawer = document.querySelector('.dc-drawer');
    var scrim = document.querySelector('.dc-scrim');
    if (!drawer) return;
    drawer.classList.add('dc-open');
    if (scrim) {
      scrim.classList.add('dc-open');
      // Inline-style backup in case any other stylesheet wins specificity.
      scrim.style.opacity = '1';
      scrim.style.pointerEvents = 'auto';
    }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var drawer = document.querySelector('.dc-drawer');
    var scrim = document.querySelector('.dc-scrim');
    if (drawer) drawer.classList.remove('dc-open');
    if (scrim) {
      scrim.classList.remove('dc-open');
      scrim.style.opacity = '';
      scrim.style.pointerEvents = '';
    }
    document.body.style.overflow = '';
  }
  // Expose for dc-home.js so the AJAX add path uses the exact same open routine.
  window.dcCart = { open: openCart, close: closeCart };
  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartClose.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });
  // Outside click on the scrim closes (use document-level delegation so it works
  // even if the scrim is re-rendered after navigation/section reload).
  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('dc-scrim')) {
      closeCart();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // ---------- Reveal-on-scroll (real IntersectionObserver) ----------
  // No-JS / reduced-motion already show full opacity via CSS.
  function revealVisibleNow() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.dc-rv:not(.dc-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('dc-in');
    });
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dc-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px', threshold: 0 }
    );
    document.querySelectorAll('.dc-rv').forEach(function (el) {
      io.observe(el);
    });
    // Belt-and-suspenders: anything visible at first paint gets revealed
    // immediately so above-the-fold content (e.g. hero CTAs) never sticks at
    // opacity:0 while we wait for IO callbacks.
    requestAnimationFrame(revealVisibleNow);
    setTimeout(revealVisibleNow, 350);
  } else {
    // Reduced motion or no IO: reveal everything immediately.
    document.querySelectorAll('.dc-rv').forEach(function (el) {
      el.classList.add('dc-in');
    });
  }
})();
